const LB = {
  ibanLength: 28,
};
export { LB };
